// extracted by mini-css-extract-plugin
export default {"game-cell":"GameCell_game-cell__uj70l","game-cell--inner":"GameCell_game-cell--inner__EGe81"};